import React from "react"

export const ExampleBlockquote = ({ keyword, text }) => {
  return (
    <div
      className="message-body has-background-mitternachtsblau-10 has-text-mitternachtsblau my-4"
      style={{ borderColor: "#034055" }}
    >
      <span className="has-text-weight-bold">{keyword}: </span>
      <span className="is-italic">{text}</span>
    </div>
  )
}
